export default {
    banner_one: '丰富的课程配置',
    banner_two: '循序渐进的课程内容',
    banner_three: '完美匹配您的中文学习需求',

    trait: '课程特色',
    trait_item1_title: '科学设计的课程体系',
    trait_item1_intro: '我们的课程设计，充分考虑了海外华侨华人子女的中文学习需求和学习特点。除了拼音、识字相关的短期课程，更有大量系统性的长期课程，帮助孩子综合提高中文运用能力。',
    trait_item2_title: '全面合理的课程内容',
    trait_item2_intro: '我们的课程涵盖了“中文基础类、技能训练类、文化兴趣类”三大类别。既能满足学员提升中文表达能力的需求，也能满足专门提升中文“阅读”和“写作”能力,以及了解更多中华传统文化的需求。',
    trait_item3_title: '丰富有趣的教材画面',
    trait_item3_intro: '我们的课程充分利用多媒体技术：大量精美的图片，音频、视频和GIF动图等多种展现形式，结合有趣的交互型游戏，让学生充分参与到课堂中，使教学更生动、练习更有趣！',

    // trait遍历内容

    interest: '趣味课堂',
    interest_item1_title: '课前预习',
    interest_item1_intro: '提前了解课程内容，建立初步印象，上课效率更高',
    interest_item2_title: '课堂互动',
    interest_item2_intro: '充分利用孩子注意力集中时间，高频互动，增加开口率',
    interest_item3_title: '课后复习',
    interest_item3_intro: '游戏化的复习系统，巩固课堂知识的同时养成良好学习习惯',

    level: '多等级课程体系，为孩子智能匹配课程',
    level_text_one: '哈兔中文的课程体系经过专业教研团队精心打造，采用最科学、严谨的方式进行分级和编排，课程共分为4个阶段、12个级别',
    level_text_two: '哈兔中文的课程契合中国小学义务教育阶段语文学习，面向海外华人孩子及有中文学习需求的孩子，针对不同中文水平孩子设置对应的教材，全面满足您的中文学习所需',
    level_text_three: '哈兔中文课堂为全程互动课堂，使孩子在高效学习的过程中有充分的时间享受我们提供的优质服务，每一步都脚踏实地，在完成既定课时后，能够达到对应级别的语言水平',
    level_text_four: '哈兔中文为您提供全面的评测，确定学员级别，并有资深顾问为您量身定制课程。',

    course: '课堂形式',
    course_item1_title: '一对一课堂',
    course_item1_intro: '根据你的学习需求，进行针对性指导，和老师一对一实时互动，享受专属教学服务，短期快速突破。',
    course_item2_title: '精选小班课',
    course_item2_intro: '为你匹配中文水平相近的小伙伴，浓厚的学习氛围，互相激发、共同进步。',
    course_item3_title: '文化大讲堂',
    course_item3_intro: '学习中华传统文化知识、习俗、礼仪，带你领略五千年的中文文化之美。',
    course_item4_title: '双师大课堂',
    course_item4_intro: '基于哈兔的专业师资、严谨丰富的课程、稳定的在线教学平台支撑，以教室与学习者为中心为海外学校的学员提供纯正优质的中文课堂。',
    // study遍历内容

    set: '课程设置',
    set_item1_title: '基础语言类',
    set_item1_intro: '多维度全方面提高学员的中文听说读写综合能力',
    set_item2_title: '分技能训练类',
    set_item2_intro: '通过对薄弱能力的补强，可以确保孩子中文学习体系的连贯性，做到循序渐进、稳中有升',
    set_item3_title: '文化兴趣类',
    set_item3_intro: '在基础课程之余，培养孩子对中文和中华文化的兴趣，促进语言技能与文化意识的整体发展',

    experience: '打造优质上课体验',
    experience_btn: '立即申请',
}